import React from 'react';
import { MainContainer } from './style';
import { MAIN_SIZE } from './constants';
import { useTheme } from '@mui/material';
import smallBlob from '../../assets/other/small-blob.png'

function Main({ children, showSmallSizeMenu }) {
    const theme = useTheme();

    return (
        <MainContainer
            component={'main'}
            sx={{
                // Fallback for browsers that do not support env()
                paddingTop: MAIN_SIZE.mt,
                '@supports (padding: env(safe-area-inset-top))': {
                    paddingTop: `calc(${MAIN_SIZE.mt} + env(safe-area-inset-top))`,
                },
                marginLeft: showSmallSizeMenu ? MAIN_SIZE.small_ml : MAIN_SIZE.large_ml,
                overflow: 'auto',

                backgroundImage: `url(${smallBlob})`,
                backgroundPosition: 'bottom right',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '108px',
                
                [theme.breakpoints.down('sm')]: {
                    padding: 0,
                    margin: 0,
                    paddingTop: MAIN_SIZE.responsive_mt,
                    '@supports (padding: env(safe-area-inset-top))': {
                        paddingTop: `calc(${MAIN_SIZE.responsive_mt} + env(safe-area-inset-top))`,
                    },
                },
            }}
        >
            {children}
        </MainContainer>
    );
}

export default Main;
